/**
 * 文件说明:
 *
 * crm constants
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import globalConstants from 'common/constants'

const constants = {
    sex: new Map([
        [1, '男'],
        [2, '女'],
        [0, '未知'],
    ]),
    messageAppUrl: '/message-control',
    materialType: {
        text: {
            type: 1,
            name: '文本',
        },
        image: {
            type: 2,
            name: '图片',
        },
        video: {
            type: 3,
            name: '视频',
        },
        file: {
            type: 4,
            name: '文件',
        },
        voice: {
            type: 5,
            name: '语音',
        },
        webPage: {
            type: 6,
            name: '网页',
        },
        miniApp: {
            type: 7,
            name: '小程序',
        },
        music: {
            type: 8,
            name: '音乐',
        },
        officialAccount: {
            type: 9,
            name: '公众号',
        },
    },
    defaultChannelTitle: '默认渠道（无渠道）',
    customerSource: {
        // 客户来源
        0: '未知来源',
        1: '扫描二维码',
        2: '搜索手机号',
        3: '名片分享',
        4: '群聊',
        5: '手机通讯录',
        6: '微信联系人',
        7: '好友申请',
        8: '自动添加',
        9: '搜索邮箱',
        201: '内部成员共享',
        202: '管理员/负责人分配',
    },
    mingchuangGender: {
        unknown: 0,
        female: 1,
        male: 2,
    },
    groupMessageType: {
        normal: {
            type: 0,
            text: '群发',
        },
        tag: {
            type: 1,
            text: '标签建群群发',
        },
    },
}

export default {
    ...globalConstants,
    ...constants,
}
